import React from "react";
import { Stack } from "@mui/material";
import { useFieldArray } from "react-hook-form";

import BarcodeValueTableHeader from "./BarcodeValueTableHeader";
import BarcodeValueTableBody from "./BarcodeValueTableBody";
import BarcodeValueTableAddRow from "./BarcodeValueTableAddRow";

const BarcodeValueTable = () => {
  const fieldArrayOptions = useFieldArray({
    name: "barcode",
  });
  const { append, fields, remove, move } = fieldArrayOptions;

  const handleAdd = (defaultValues = {}) =>
    append({
      field: null,
      format: 1,
      padding: null,
      ...defaultValues,
    });

  const props = { handleAdd, remove, move, fields };

  return (
    <Stack overflowX="auto" width="100%">
      <BarcodeValueTableHeader />
      <BarcodeValueTableBody {...props} />
      <BarcodeValueTableAddRow handleAdd={handleAdd} />
    </Stack>
  );
};

export default BarcodeValueTable;
